(function(angular, _) {
    'use strict';

    angular.module('um').controller('main.controller', mainCtrl);
    mainCtrl.$inject = ['$scope', '$state', '$translate', 'myself', 'myCompany', 'trackingService', 'endpoints'];
    function mainCtrl($scope, $state, $translate, myself, myCompany, trackingService, endpoints) {
        var that = this;

        that.accountForSupport = {
            id: 100000020686800,
            name: 'Knigge DE Portal (Preview, intern)'
        };

        // adds the given class to body and stops pace by doing so
        var className = 'application-loaded';
        if (!angular.element('body').hasClass(className)) {
            angular.element('body').addClass(className);
        }

        that.state = $state;
        $('#app-initialize-overlay').hide();

        let language = 'en';
        const loginName = _.get(myself, 'loginName', '');
        const emailHash = _.get(myself, 'emailHash', '');

        if (_.has(myself, 'language')) {
            language = myself.language.toLowerCase();
        }
        $translate.use(language);

        trackingService.init({
            language: language,
            product: 'user-management',
            loginName: loginName,
            account: '',            // no account for this product
            userHash: emailHash,
            trackId: ''             // no trackId for this product
        });

        that.myProfile = $state.includes('main.profile');
        var productsUrl = that.myProfile ? endpoints.ssoMenuMYP : endpoints.ssoMenu;

        that.support_lang = language === 'de' ? 'de' : 'en';

        that.config = {
            productsUrl: productsUrl.url,
            companyName: myCompany.loginNamePrefix,
            menuItems: []
        };

        // defines menu entries on either UM or myProfile
        that.defineMenu = function defineMenu(profile) {
            that.config.menuItems.splice(0, that.config.menuItems.length);
            if (profile) {
                that.config.menuItems
                    .push({icon: 'wti-profile', title: 'SETTINGS', state: 'main.profile.edit', id: 1});
                that.config.menuItems
                    .push({icon: 'wti-lock', title: 'CHANGE_PASSWORD', state: 'main.profile.password', id: 2});
            } else {
                that.config.menuItems
                    .push({icon: 'wti-users', title: 'USERS', state: 'main.users.overview', id: 3});
                that.config.menuItems
                    .push({icon: 'wti-roles', title: 'ROLES', state: 'main.roles.overview', id: 4});
                that.config.menuItems
                    .push({icon: 'wti-categories', title: 'CATEGORIES', state: 'main.categories.overview', id: 5});
                that.config.menuItems
                    .push({icon: 'wti-funnel', title: 'FILTERS', state: 'main.filters.overview', id: 6});
            }
        };
        that.defineMenu(that.myProfile);

        var newStateIsProfile;
        var oldStateWasProfile = that.myProfile;
        // General Tracking
        $scope.$on('$stateChangeSuccess', function(event, state) {
            if (!state.name.includes('main.users.import')) {
                trackingService.page(state.name.replace('main.', ''));
                newStateIsProfile = state.name.includes('profile');
                that.myProfile = newStateIsProfile;

                // TODO change after myProfile and UM gets separated
                if (newStateIsProfile !== oldStateWasProfile) {
                    that.defineMenu(newStateIsProfile);
                    oldStateWasProfile = newStateIsProfile;
                    $state.reload();
                }
            }
        });

        $scope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
            $state.go(fromState.name, null, {reload: true});
        });

        $scope.$on('wtMenu:feedbackClicked', function() {
            window.jiraFeedbackPopup();
        });
    }
})(window.angular, window._);
